
import { Link } from 'react-router-dom';

export default function AboutCTA() {
  return (
    <section className="py-16 md:py-24 lg:py-28 relative overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/a526804b3140d6a44cae16431c172934.jpg" 
          alt="Luxury renovation result" 
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-6 md:space-y-8">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight">
          Ready to Build Something <span className="font-serif text-[#D4AF37]">Extraordinary</span>?
        </h2>
        <p className="text-base sm:text-lg md:text-xl text-white/80 leading-relaxed max-w-2xl mx-auto">
          Whether it&apos;s a luxury home renovation or a premium commercial fit-out, Tadashi Consulting delivers excellence from first inspection to final handover.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-5 pt-2 md:pt-4">
          <Link 
            to="/residential-renovations" 
            className="px-8 md:px-10 py-3.5 md:py-4 bg-[#D4AF37] text-white text-sm md:text-base font-semibold rounded-full hover:bg-[#B8941F] transition-all shadow-lg whitespace-nowrap cursor-pointer"
          >
            Residential Services
          </Link>
          <Link 
            to="/commercial-construction" 
            className="px-8 md:px-10 py-3.5 md:py-4 border-2 border-white/60 text-white text-sm md:text-base font-semibold rounded-full hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
          >
            Commercial Services
          </Link>
        </div>
      </div>
    </section>
  );
}
